import axios from 'axios';

import { env } from 'config';
import {
  ProviderType,
  CreateProviderTypeDto,
  UpdateProviderTypeDto,
  PaginatedData,
  QueryParams,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/provider-types`;

export const providerTypesApi = {
  getAll: async (): Promise<ProviderType[]> => (await axios.get(url)).data,

  getAllActive: async (): Promise<ProviderType[]> =>
    (await axios.get(url)).data,

  getAllIncludingInactive: async (): Promise<ProviderType[]> =>
    (await axios.get(`${url}/all`)).data,

  getAllPaginated: async (
    params?: Partial<QueryParams>,
  ): Promise<PaginatedData<ProviderType>> =>
    (await apiUtils.getWithQueryParams(`${url}/paginated`, params)).data,

  getOne: async (id: string): Promise<ProviderType> =>
    (await axios.get(`${url}/${id}`)).data,

  create: async (data: CreateProviderTypeDto): Promise<ProviderType> =>
    (await axios.post(url, data)).data,

  update: async ({
    id,
    data,
  }: {
    id: string;
    data: UpdateProviderTypeDto;
  }): Promise<ProviderType> => (await axios.patch(`${url}/${id}`, data)).data,

  remove: async (id: string): Promise<void> =>
    (await axios.delete(`${url}/${id}`)).data,

  activate: async (id: string): Promise<ProviderType> =>
    (await axios.post(`${url}/${id}/activate`)).data,

  deactivate: async (id: string): Promise<ProviderType> =>
    (await axios.post(`${url}/${id}/deactivate`)).data,
};
